import { Form } from "@unform/web";
import { useRef, useState } from "react";

import NexLogo from "Assets/Admin/NexLogo.svg";

import { HTTPErrorCallback } from "Helpers/Error";
import { getPasswordSecurityVerifications } from "Helpers/Password";

import UseServices from "Hooks/UseServices";

import PrimaryButton from "Components/Global/Buttons/Variants/Primary";
import Input from "Components/Global/Form/Input";
import SafePassword from "Components/Global/SafePassword";
import TypographyHead from "Components/Global/Typography/Head";

import * as S from "../../../styles";

const NewPassword = ({ loading, setLoading, setLoginStep, code, userId }) => {
  const formRef = useRef();
  const { api } = UseServices();
  const [password, setPassword] = useState({});

  const submitNewPassword = (data) => {
    setLoading(true);
    const verifications = getPasswordSecurityVerifications(data.password);

    if (
      !verifications.hasEnoughLength ||
      !verifications.hasNumber ||
      !verifications.hasUppercase ||
      !verifications.hasSpecialCharacters
    ) {
      setLoading(false);
      return formRef.current.setErrors({
        password: JSON.stringify({
          type: "error",
          message: "Insira uma senha mais segura",
        }),
      });
    }

    api
      .post("/reset-password", { ...data, user_id: userId, code })
      .then(() => {
        setLoading(false);
        setLoginStep("password");
      })
      .catch((error) => {
        HTTPErrorCallback(error);
        setLoading(false);
      });
  };

  return (
    <S.Wrapper>
      <S.Row>
        <img src={NexLogo} alt="Movemeta Logo" />
        <TypographyHead
          dark
          title="Nova senha"
          description="Digite uma nova senha segura para sua conta"
        />
      </S.Row>
      <Form onSubmit={submitNewPassword} ref={formRef}>
        <S.Row>
          <Input
            type="password"
            required
            name="password"
            label="Nova senha"
            onChange={(e) => setPassword(e.target.value)}
            placeholder="*******"
          />

          <SafePassword password={password} />
          <PrimaryButton
            text="Redefinir Senha"
            type="submit"
            disabled={loading}
          />
        </S.Row>
      </Form>
    </S.Wrapper>
  );
};

export default NewPassword;
